/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FrIndexRouteImport } from './routes/fr/index'
import { Route as EnIndexRouteImport } from './routes/en/index'
import { Route as FrFonctionnalitesRouteImport } from './routes/fr/fonctionnalites'
import { Route as FrFaqRouteImport } from './routes/fr/faq'
import { Route as FrContactRouteImport } from './routes/fr/contact'
import { Route as FrCasDUsageRouteImport } from './routes/fr/cas-d-usage'
import { Route as EnUseCasesRouteImport } from './routes/en/use-cases'
import { Route as EnFeaturesRouteImport } from './routes/en/features'
import { Route as EnFaqRouteImport } from './routes/en/faq'
import { Route as EnContactRouteImport } from './routes/en/contact'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthenticatedWatchlistsRouteImport } from './routes/_authenticated/watchlists'
import { Route as AuthenticatedTransactionsRouteImport } from './routes/_authenticated/transactions'
import { Route as AuthenticatedSuccessRouteImport } from './routes/_authenticated/success'
import { Route as AuthenticatedScreenerRouteImport } from './routes/_authenticated/screener'
import { Route as AuthenticatedPortfolioRouteImport } from './routes/_authenticated/portfolio'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedBudgetRouteImport } from './routes/_authenticated/budget'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedScreenerAssetIdRouteImport } from './routes/_authenticated/screener.$assetId'
import { Route as AuthenticatedAdminFeedbacksRouteImport } from './routes/_authenticated/admin/feedbacks'
import { Route as AuthenticatedAdminAssetsRouteImport } from './routes/_authenticated/admin/assets'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FrIndexRoute = FrIndexRouteImport.update({
  id: '/fr/',
  path: '/fr/',
  getParentRoute: () => rootRouteImport,
} as any)
const EnIndexRoute = EnIndexRouteImport.update({
  id: '/en/',
  path: '/en/',
  getParentRoute: () => rootRouteImport,
} as any)
const FrFonctionnalitesRoute = FrFonctionnalitesRouteImport.update({
  id: '/fr/fonctionnalites',
  path: '/fr/fonctionnalites',
  getParentRoute: () => rootRouteImport,
} as any)
const FrFaqRoute = FrFaqRouteImport.update({
  id: '/fr/faq',
  path: '/fr/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const FrContactRoute = FrContactRouteImport.update({
  id: '/fr/contact',
  path: '/fr/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const FrCasDUsageRoute = FrCasDUsageRouteImport.update({
  id: '/fr/cas-d-usage',
  path: '/fr/cas-d-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const EnUseCasesRoute = EnUseCasesRouteImport.update({
  id: '/en/use-cases',
  path: '/en/use-cases',
  getParentRoute: () => rootRouteImport,
} as any)
const EnFeaturesRoute = EnFeaturesRouteImport.update({
  id: '/en/features',
  path: '/en/features',
  getParentRoute: () => rootRouteImport,
} as any)
const EnFaqRoute = EnFaqRouteImport.update({
  id: '/en/faq',
  path: '/en/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const EnContactRoute = EnContactRouteImport.update({
  id: '/en/contact',
  path: '/en/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWatchlistsRoute = AuthenticatedWatchlistsRouteImport.update({
  id: '/watchlists',
  path: '/watchlists',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTransactionsRoute =
  AuthenticatedTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuccessRoute = AuthenticatedSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScreenerRoute = AuthenticatedScreenerRouteImport.update({
  id: '/screener',
  path: '/screener',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPortfolioRoute = AuthenticatedPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBudgetRoute = AuthenticatedBudgetRouteImport.update({
  id: '/budget',
  path: '/budget',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScreenerAssetIdRoute =
  AuthenticatedScreenerAssetIdRouteImport.update({
    id: '/$assetId',
    path: '/$assetId',
    getParentRoute: () => AuthenticatedScreenerRoute,
  } as any)
const AuthenticatedAdminFeedbacksRoute =
  AuthenticatedAdminFeedbacksRouteImport.update({
    id: '/admin/feedbacks',
    path: '/admin/feedbacks',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminAssetsRoute =
  AuthenticatedAdminAssetsRouteImport.update({
    id: '/admin/assets',
    path: '/admin/assets',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contact-us': typeof ContactUsRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/account': typeof AuthenticatedAccountRoute
  '/budget': typeof AuthenticatedBudgetRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/portfolio': typeof AuthenticatedPortfolioRoute
  '/screener': typeof AuthenticatedScreenerRouteWithChildren
  '/success': typeof AuthenticatedSuccessRoute
  '/transactions': typeof AuthenticatedTransactionsRoute
  '/watchlists': typeof AuthenticatedWatchlistsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/en/contact': typeof EnContactRoute
  '/en/faq': typeof EnFaqRoute
  '/en/features': typeof EnFeaturesRoute
  '/en/use-cases': typeof EnUseCasesRoute
  '/fr/cas-d-usage': typeof FrCasDUsageRoute
  '/fr/contact': typeof FrContactRoute
  '/fr/faq': typeof FrFaqRoute
  '/fr/fonctionnalites': typeof FrFonctionnalitesRoute
  '/en/': typeof EnIndexRoute
  '/fr/': typeof FrIndexRoute
  '/admin/assets': typeof AuthenticatedAdminAssetsRoute
  '/admin/feedbacks': typeof AuthenticatedAdminFeedbacksRoute
  '/screener/$assetId': typeof AuthenticatedScreenerAssetIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contact-us': typeof ContactUsRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/account': typeof AuthenticatedAccountRoute
  '/budget': typeof AuthenticatedBudgetRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/portfolio': typeof AuthenticatedPortfolioRoute
  '/screener': typeof AuthenticatedScreenerRouteWithChildren
  '/success': typeof AuthenticatedSuccessRoute
  '/transactions': typeof AuthenticatedTransactionsRoute
  '/watchlists': typeof AuthenticatedWatchlistsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/en/contact': typeof EnContactRoute
  '/en/faq': typeof EnFaqRoute
  '/en/features': typeof EnFeaturesRoute
  '/en/use-cases': typeof EnUseCasesRoute
  '/fr/cas-d-usage': typeof FrCasDUsageRoute
  '/fr/contact': typeof FrContactRoute
  '/fr/faq': typeof FrFaqRoute
  '/fr/fonctionnalites': typeof FrFonctionnalitesRoute
  '/en': typeof EnIndexRoute
  '/fr': typeof FrIndexRoute
  '/admin/assets': typeof AuthenticatedAdminAssetsRoute
  '/admin/feedbacks': typeof AuthenticatedAdminFeedbacksRoute
  '/screener/$assetId': typeof AuthenticatedScreenerAssetIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/contact-us': typeof ContactUsRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authenticated/account': typeof AuthenticatedAccountRoute
  '/_authenticated/budget': typeof AuthenticatedBudgetRoute
  '/_authenticated/calendar': typeof AuthenticatedCalendarRoute
  '/_authenticated/portfolio': typeof AuthenticatedPortfolioRoute
  '/_authenticated/screener': typeof AuthenticatedScreenerRouteWithChildren
  '/_authenticated/success': typeof AuthenticatedSuccessRoute
  '/_authenticated/transactions': typeof AuthenticatedTransactionsRoute
  '/_authenticated/watchlists': typeof AuthenticatedWatchlistsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/en/contact': typeof EnContactRoute
  '/en/faq': typeof EnFaqRoute
  '/en/features': typeof EnFeaturesRoute
  '/en/use-cases': typeof EnUseCasesRoute
  '/fr/cas-d-usage': typeof FrCasDUsageRoute
  '/fr/contact': typeof FrContactRoute
  '/fr/faq': typeof FrFaqRoute
  '/fr/fonctionnalites': typeof FrFonctionnalitesRoute
  '/en/': typeof EnIndexRoute
  '/fr/': typeof FrIndexRoute
  '/_authenticated/admin/assets': typeof AuthenticatedAdminAssetsRoute
  '/_authenticated/admin/feedbacks': typeof AuthenticatedAdminFeedbacksRoute
  '/_authenticated/screener/$assetId': typeof AuthenticatedScreenerAssetIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact-us'
    | '/login'
    | '/register'
    | '/account'
    | '/budget'
    | '/calendar'
    | '/portfolio'
    | '/screener'
    | '/success'
    | '/transactions'
    | '/watchlists'
    | '/auth/callback'
    | '/en/contact'
    | '/en/faq'
    | '/en/features'
    | '/en/use-cases'
    | '/fr/cas-d-usage'
    | '/fr/contact'
    | '/fr/faq'
    | '/fr/fonctionnalites'
    | '/en/'
    | '/fr/'
    | '/admin/assets'
    | '/admin/feedbacks'
    | '/screener/$assetId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact-us'
    | '/login'
    | '/register'
    | '/account'
    | '/budget'
    | '/calendar'
    | '/portfolio'
    | '/screener'
    | '/success'
    | '/transactions'
    | '/watchlists'
    | '/auth/callback'
    | '/en/contact'
    | '/en/faq'
    | '/en/features'
    | '/en/use-cases'
    | '/fr/cas-d-usage'
    | '/fr/contact'
    | '/fr/faq'
    | '/fr/fonctionnalites'
    | '/en'
    | '/fr'
    | '/admin/assets'
    | '/admin/feedbacks'
    | '/screener/$assetId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/contact-us'
    | '/login'
    | '/register'
    | '/_authenticated/account'
    | '/_authenticated/budget'
    | '/_authenticated/calendar'
    | '/_authenticated/portfolio'
    | '/_authenticated/screener'
    | '/_authenticated/success'
    | '/_authenticated/transactions'
    | '/_authenticated/watchlists'
    | '/auth/callback'
    | '/en/contact'
    | '/en/faq'
    | '/en/features'
    | '/en/use-cases'
    | '/fr/cas-d-usage'
    | '/fr/contact'
    | '/fr/faq'
    | '/fr/fonctionnalites'
    | '/en/'
    | '/fr/'
    | '/_authenticated/admin/assets'
    | '/_authenticated/admin/feedbacks'
    | '/_authenticated/screener/$assetId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ContactUsRoute: typeof ContactUsRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  EnContactRoute: typeof EnContactRoute
  EnFaqRoute: typeof EnFaqRoute
  EnFeaturesRoute: typeof EnFeaturesRoute
  EnUseCasesRoute: typeof EnUseCasesRoute
  FrCasDUsageRoute: typeof FrCasDUsageRoute
  FrContactRoute: typeof FrContactRoute
  FrFaqRoute: typeof FrFaqRoute
  FrFonctionnalitesRoute: typeof FrFonctionnalitesRoute
  EnIndexRoute: typeof EnIndexRoute
  FrIndexRoute: typeof FrIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fr/': {
      id: '/fr/'
      path: '/fr'
      fullPath: '/fr/'
      preLoaderRoute: typeof FrIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/': {
      id: '/en/'
      path: '/en'
      fullPath: '/en/'
      preLoaderRoute: typeof EnIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fr/fonctionnalites': {
      id: '/fr/fonctionnalites'
      path: '/fr/fonctionnalites'
      fullPath: '/fr/fonctionnalites'
      preLoaderRoute: typeof FrFonctionnalitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fr/faq': {
      id: '/fr/faq'
      path: '/fr/faq'
      fullPath: '/fr/faq'
      preLoaderRoute: typeof FrFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fr/contact': {
      id: '/fr/contact'
      path: '/fr/contact'
      fullPath: '/fr/contact'
      preLoaderRoute: typeof FrContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fr/cas-d-usage': {
      id: '/fr/cas-d-usage'
      path: '/fr/cas-d-usage'
      fullPath: '/fr/cas-d-usage'
      preLoaderRoute: typeof FrCasDUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/use-cases': {
      id: '/en/use-cases'
      path: '/en/use-cases'
      fullPath: '/en/use-cases'
      preLoaderRoute: typeof EnUseCasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/features': {
      id: '/en/features'
      path: '/en/features'
      fullPath: '/en/features'
      preLoaderRoute: typeof EnFeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/faq': {
      id: '/en/faq'
      path: '/en/faq'
      fullPath: '/en/faq'
      preLoaderRoute: typeof EnFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/contact': {
      id: '/en/contact'
      path: '/en/contact'
      fullPath: '/en/contact'
      preLoaderRoute: typeof EnContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/watchlists': {
      id: '/_authenticated/watchlists'
      path: '/watchlists'
      fullPath: '/watchlists'
      preLoaderRoute: typeof AuthenticatedWatchlistsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transactions': {
      id: '/_authenticated/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AuthenticatedTransactionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/success': {
      id: '/_authenticated/success'
      path: '/success'
      fullPath: '/success'
      preLoaderRoute: typeof AuthenticatedSuccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/screener': {
      id: '/_authenticated/screener'
      path: '/screener'
      fullPath: '/screener'
      preLoaderRoute: typeof AuthenticatedScreenerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/portfolio': {
      id: '/_authenticated/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof AuthenticatedPortfolioRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar': {
      id: '/_authenticated/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/budget': {
      id: '/_authenticated/budget'
      path: '/budget'
      fullPath: '/budget'
      preLoaderRoute: typeof AuthenticatedBudgetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/screener/$assetId': {
      id: '/_authenticated/screener/$assetId'
      path: '/$assetId'
      fullPath: '/screener/$assetId'
      preLoaderRoute: typeof AuthenticatedScreenerAssetIdRouteImport
      parentRoute: typeof AuthenticatedScreenerRoute
    }
    '/_authenticated/admin/feedbacks': {
      id: '/_authenticated/admin/feedbacks'
      path: '/admin/feedbacks'
      fullPath: '/admin/feedbacks'
      preLoaderRoute: typeof AuthenticatedAdminFeedbacksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/assets': {
      id: '/_authenticated/admin/assets'
      path: '/admin/assets'
      fullPath: '/admin/assets'
      preLoaderRoute: typeof AuthenticatedAdminAssetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedScreenerRouteChildren {
  AuthenticatedScreenerAssetIdRoute: typeof AuthenticatedScreenerAssetIdRoute
}

const AuthenticatedScreenerRouteChildren: AuthenticatedScreenerRouteChildren = {
  AuthenticatedScreenerAssetIdRoute: AuthenticatedScreenerAssetIdRoute,
}

const AuthenticatedScreenerRouteWithChildren =
  AuthenticatedScreenerRoute._addFileChildren(
    AuthenticatedScreenerRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedBudgetRoute: typeof AuthenticatedBudgetRoute
  AuthenticatedCalendarRoute: typeof AuthenticatedCalendarRoute
  AuthenticatedPortfolioRoute: typeof AuthenticatedPortfolioRoute
  AuthenticatedScreenerRoute: typeof AuthenticatedScreenerRouteWithChildren
  AuthenticatedSuccessRoute: typeof AuthenticatedSuccessRoute
  AuthenticatedTransactionsRoute: typeof AuthenticatedTransactionsRoute
  AuthenticatedWatchlistsRoute: typeof AuthenticatedWatchlistsRoute
  AuthenticatedAdminAssetsRoute: typeof AuthenticatedAdminAssetsRoute
  AuthenticatedAdminFeedbacksRoute: typeof AuthenticatedAdminFeedbacksRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedBudgetRoute: AuthenticatedBudgetRoute,
  AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,
  AuthenticatedPortfolioRoute: AuthenticatedPortfolioRoute,
  AuthenticatedScreenerRoute: AuthenticatedScreenerRouteWithChildren,
  AuthenticatedSuccessRoute: AuthenticatedSuccessRoute,
  AuthenticatedTransactionsRoute: AuthenticatedTransactionsRoute,
  AuthenticatedWatchlistsRoute: AuthenticatedWatchlistsRoute,
  AuthenticatedAdminAssetsRoute: AuthenticatedAdminAssetsRoute,
  AuthenticatedAdminFeedbacksRoute: AuthenticatedAdminFeedbacksRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ContactUsRoute: ContactUsRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  EnContactRoute: EnContactRoute,
  EnFaqRoute: EnFaqRoute,
  EnFeaturesRoute: EnFeaturesRoute,
  EnUseCasesRoute: EnUseCasesRoute,
  FrCasDUsageRoute: FrCasDUsageRoute,
  FrContactRoute: FrContactRoute,
  FrFaqRoute: FrFaqRoute,
  FrFonctionnalitesRoute: FrFonctionnalitesRoute,
  EnIndexRoute: EnIndexRoute,
  FrIndexRoute: FrIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
